export * from '../../state/info/selectors';



/** WEBPACK FOOTER **
 ** ./src/members/__shared__/selectors/info.js
 **/